import { useOutletContext } from "react-router-dom";

import DigikalaOrders from "../components/DigikalaOrders";

export default function DigikalaSellerOrdersPage() {
  const data = useOutletContext();
  return (
    <div>
      <DigikalaOrders getSellerData={data} />
    </div>
  );
}
